import { MeetingSessionConfiguration } from 'amazon-chime-sdk-js';

import { FeatureFlagService } from 'features/feature-toggle/services';
import {
  getChimeMeetingTimingFlag,
  resolveChimeMeetingTimingConfig,
} from 'features/voice-meeting/constants';

/**
 * Builds the Chime meeting configuration with connect and reconnect timing
 * from the chimeMeetingTiming LaunchDarkly flag (defaults apply when absent).
 * The SDK builds its reconnect controller from these values in the
 * DefaultMeetingSession constructor, so they must be set before the session
 * is created.
 */
export const createChimeMeetingConfiguration = (
  ...args: ConstructorParameters<typeof MeetingSessionConfiguration>
): MeetingSessionConfiguration => {
  const configuration = new MeetingSessionConfiguration(...args);
  const timing = resolveChimeMeetingTimingConfig(
    getChimeMeetingTimingFlag(FeatureFlagService.getInstance().flags)
  );

  configuration.connectionTimeoutMs = timing.connectionTimeoutMs;
  configuration.reconnectShortBackOffMs = timing.reconnectShortBackOffMs;
  configuration.reconnectLongBackOffMs = timing.reconnectLongBackOffMs;

  return configuration;
};
